import { getCalculatorAPIClient } from './axios';

export const calculatorApi = getCalculatorAPIClient();
